import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../../contexts/AppContext';
import AlertModal from '../../components/AlertModal';
import styles from './index.module.scss';

const UploadProcess = () => {
  const navigate = useNavigate();
  const { addProcessToAudit, showAlert, alertModal, closeAlert } = useAppContext();
  const [formData, setFormData] = useState({
    processName: '',
    processType: '',
    description: '',
    steps: '',
    materials: '',
    equipment: '',
    parameters: '',
    notes: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // 验证必填字段
    if (!formData.processName.trim()) {
      await showAlert('warning', '输入错误', '请输入工艺名称');
      return;
    }
    if (!formData.processType) {
      await showAlert('warning', '输入错误', '请选择工艺类型');
      return;
    }
    if (!formData.description.trim()) {
      await showAlert('warning', '输入错误', '请输入工艺描述');
      return;
    }

    try {
      // 添加工艺到审核列表
      console.log('提交的工艺数据:', formData);
      await addProcessToAudit(formData);
      await showAlert('success', '提交成功', '工艺上传成功！已提交审核。');
      // 跳转回主页
      navigate('/');
    } catch (error) {
      console.error('上传工艺失败:', error);
      await showAlert('error', '提交失败', '上传失败，请重试');
    }
  };

  const handleBack = () => {
    navigate('/');
  };

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <div className={styles.headerContent}>
          <button className={styles.backButton} onClick={handleBack}>
            ← 返回主页
          </button>
          <h1>上传新工艺</h1>
          <div></div>
        </div>
      </header>

      <div className={styles.content}>
        <div className={styles.formContainer}>
          <form onSubmit={handleSubmit} className={styles.form}>
            <div className={styles.formGroup}>
              <label htmlFor="processName">工艺名称 *</label>
              <input
                type="text"
                id="processName"
                name="processName"
                value={formData.processName}
                onChange={handleInputChange}
                required
                placeholder="请输入工艺名称"
              />
            </div>

            <div className={styles.formGroup}>
              <label htmlFor="processType">工艺类型 *</label>
              <select
                id="processType"
                name="processType"
                value={formData.processType}
                onChange={handleInputChange}
                required
              >
                <option value="">请选择工艺类型</option>
                <option value="曝光文件准备 / 版图设计">曝光文件准备 / 版图设计</option>
                <option value="表面改性">表面改性</option>
                <option value="剥离">剥离</option>
                <option value="热处理">热处理</option>
                <option value="清洗">清洗</option>
                <option value="匀胶">匀胶</option>
                <option value="曝光">曝光</option>
                <option value="显影">显影</option>
                <option value="去底胶">去底胶</option>
                <option value="沉积">沉积</option>
                <option value="刻蚀">刻蚀</option>
                <option value="去胶清洗">去胶清洗</option>
              </select>
            </div>

            <div className={styles.formGroup}>
              <label htmlFor="description">工艺描述 *</label>
              <textarea
                id="description"
                name="description"
                value={formData.description}
                onChange={handleInputChange}
                required
                placeholder="请详细描述工艺的目的和原理"
                rows="4"
              />
            </div>

            <div className={styles.formGroup}>
              <label htmlFor="steps">工艺步骤 *</label>
              <textarea
                id="steps"
                name="steps"
                value={formData.steps}
                onChange={handleInputChange}
                required
                placeholder="请详细列出工艺的具体步骤"
                rows="6"
              />
            </div>

            <div className={styles.formGroup}>
              <label htmlFor="materials">所需材料</label>
              <textarea
                id="materials"
                name="materials"
                value={formData.materials}
                onChange={handleInputChange}
                placeholder="请列出所需的材料和化学品"
                rows="3"
              />
            </div>

            <div className={styles.formGroup}>
              <label htmlFor="equipment">所需设备</label>
              <textarea
                id="equipment"
                name="equipment"
                value={formData.equipment}
                onChange={handleInputChange}
                placeholder="请列出所需的设备和仪器"
                rows="3"
              />
            </div>

            <div className={styles.formGroup}>
              <label htmlFor="parameters">工艺参数</label>
              <textarea
                id="parameters"
                name="parameters"
                value={formData.parameters}
                onChange={handleInputChange}
                placeholder="请列出关键的工艺参数（温度、压力、时间等）"
                rows="4"
              />
            </div>

            <div className={styles.formGroup}>
              <label htmlFor="notes">备注</label>
              <textarea
                id="notes"
                name="notes"
                value={formData.notes}
                onChange={handleInputChange}
                placeholder="其他需要注意的事项"
                rows="3"
              />
            </div>

            <div className={styles.buttonGroup}>
              <button type="button" className={styles.cancelButton} onClick={handleBack}>
                取消
              </button>
              <button type="submit" className={styles.submitButton}>
                提交工艺
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* 弹窗组件 */}
      <AlertModal
        isOpen={alertModal.isOpen}
        type={alertModal.type}
        title={alertModal.title}
        message={alertModal.message}
        confirmText={alertModal.confirmText}
        cancelText={alertModal.cancelText}
        showCancel={alertModal.showCancel}
        onConfirm={alertModal.onConfirm}
        onCancel={alertModal.onCancel}
        onClose={closeAlert}
      />
    </div>
  );
};

export default UploadProcess;
